// @index('./*', pp => `export * from "${pp.path}";`)
export * from './BackupAction';
export * from './ErrorCode';
export * from './IAudit';
export * from './IAuditDbRow';
export * from './IBackup';
export * from './IBackupDbRow';
export * from './IBackupParams';
export * from './ICollectionResponse';
export * from './IDbRow';
export * from './IDeleteResponse';
export * from './IListRequest';
export * from './IPagingOptions';
export * from './IQueryString';
export * from './IServiceResponse';
export * from './PortalPermissions';
export * from './query';
export * from './statistics';
export * from './TDataType';
export * from './TExtended';
export * from './TServicePromise';
